import { render, staticRenderFns } from "./posterCenter.vue?vue&type=template&id=74694a3a&scoped=true&"
import script from "./posterCenter.vue?vue&type=script&lang=js&"
export * from "./posterCenter.vue?vue&type=script&lang=js&"
import style0 from "./posterCenter.vue?vue&type=style&index=0&id=74694a3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74694a3a",
  null
  
)

export default component.exports